import { render, staticRenderFns } from "./CreateMessengerChannel.vue?vue&type=template&id=71990429&scoped=true"
import script from "./CreateMessengerChannel.vue?vue&type=script&lang=js"
export * from "./CreateMessengerChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateMessengerChannel.vue?vue&type=style&index=0&id=71990429&prod&lang=scss&scoped=true"
import style1 from "./CreateMessengerChannel.vue?vue&type=style&index=1&id=71990429&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71990429",
  null
  
)

export default component.exports